export const nacionalitiesList = [
  { id: 0, name: 'Otros Orígenes Desconocidos' },
  { id: 100, name: 'Territorio Británico en Asia' },
  { id: 101, name: 'Senegal' },
  { id: 102, name: 'Gambia' },
  { id: 103, name: 'Guinea - Bissau' },
  { id: 104, name: 'Guinea' },
  { id: 105, name: 'Sierra Leona' },
  { id: 106, name: 'Liberia' },
  { id: 107, name: 'Costa de Marfil' },
  { id: 108, name: 'Ghana' },
  { id: 109, name: 'Togo' },
  { id: 111, name: 'Nigeria' },
  { id: 112, name: 'Sudáfrica' },
  { id: 113, name: 'Botswana' },
  { id: 114, name: 'Lesotho' },
  { id: 115, name: 'Malawi' },
  { id: 116, name: 'Zimbabwe' },
  { id: 117, name: 'Zambia' },
  { id: 118, name: 'Comoras' },
  { id: 119, name: 'Mauricio' },
  { id: 120, name: 'Madagascar' },
  { id: 121, name: 'Mozambique' },
  { id: 122, name: 'Swazilandia' },
  { id: 123, name: 'Sudán' },
  { id: 124, name: 'Egipto' },
  { id: 125, name: 'Libia' },
  { id: 126, name: 'Tunez' },
  { id: 127, name: 'Argelia' },
  { id: 128, name: 'Marruecos' },
  { id: 129, name: 'Cabo Verde' },
  { id: 130, name: 'Chad' },
  { id: 131, name: 'Niger' },
  { id: 132, name: 'Alto Volta' },
  { id: 133, name: 'Mali' },
  { id: 134, name: 'Mauritania' },
  { id: 135, name: 'Tanzania' },
  { id: 136, name: 'Uganda' },
  { id: 137, name: 'Kenia' },
  { id: 138, name: 'Somalia' },
  { id: 139, name: 'Etiopia' },
  { id: 140, name: 'Angola' },
  { id: 141, name: 'Burundi' },
  { id: 142, name: 'Rwanda' },
  { id: 143, name: 'República Democratica del Congo (ex Zaire)' },
  { id: 144, name: 'República del Congo' },
  { id: 145, name: 'Gabon' },
  { id: 146, name: 'Sao Tome y Príncipe' },
  { id: 147, name: 'Guinea Ecuatorial' },
  { id: 148, name: 'República Centroafricana' },
  { id: 149, name: 'Camerún' },
  { id: 150, name: 'Benín' },
  { id: 151, name: 'Territorio Britanico en Africa' },
  { id: 152, name: 'Territorio Español en África' },
  { id: 153, name: 'Territorio Francés en África' },
  { id: 154, name: 'Bophuthatswana' },
  { id: 155, name: 'Djibouti' },
  { id: 156, name: 'Seychelles' },
  { id: 158, name: 'Vienda' },
  { id: 159, name: 'Namibia' },
  { id: 160, name: 'Sudán del Sur' },
  { id: 161, name: 'Burkina Faso' },
  { id: 162, name: 'Ciskey' },
  { id: 163, name: 'Eritrea' },
  { id: 164, name: 'Islas Marshall' },
  { id: 165, name: 'Saharavi' },
  { id: 166, name: 'Transkei' },
  { id: 201, name: 'Venezuela' },
  { id: 202, name: 'Colombia' },
  { id: 203, name: 'Trinidad y Tobago' },
  { id: 204, name: 'Barbados' },
  { id: 205, name: 'Jamaica' },
  { id: 206, name: 'República Dominicana' },
  { id: 207, name: 'Bahamas' },
  { id: 208, name: 'Haití' },
  { id: 209, name: 'Cuba' },
  { id: 210, name: 'Panamá' },
  { id: 211, name: 'Costa Rica' },
  { id: 212, name: 'Nicaragua' },
  { id: 213, name: 'El Salvador' },
  { id: 214, name: 'Honduras' },
  { id: 215, name: 'Guatemala' },
  { id: 216, name: 'México' },
  { id: 217, name: 'Guyana' },
  { id: 218, name: 'Ecuador' },
  { id: 219, name: 'Perú' },
  { id: 220, name: 'Brasil' },
  { id: 221, name: 'Bolivia' },
  { id: 222, name: 'Paraguay' },
  { id: 223, name: 'Uruguay' },
  { id: 224, name: 'Argentina' },
  { id: 225, name: 'Estados Unidos de América' },
  { id: 226, name: 'Canadá' },
  { id: 227, name: 'Territorio Británico en América' },
  { id: 228, name: 'Territorio Francés en América' },
  { id: 229, name: 'Territorio Holandes en América' },
  { id: 230, name: 'Territorio de Dinamarca en América' },
  { id: 231, name: 'Dominica' },
  { id: 232, name: 'Granada' },
  { id: 233, name: 'Santa Lucía (Islas  Occidentales)' },
  { id: 234, name: 'San Vicente y las Granadinas' },
  { id: 235, name: 'Surinam' },
  { id: 236, name: 'Belice' },
  { id: 240, name: 'Antigua y Barbuda' },
  { id: 241, name: 'Saint Kitts & Nevis' },
  { id: 242, name: 'Anguila' },
  { id: 243, name: 'Aruba' },
  { id: 244, name: 'Bermudas' },
  { id: 245, name: 'Islas Virgenes Britanicas' },
  { id: 246, name: 'Islas Caymán' },
  { id: 247, name: 'Antillas Neerlandesas' },
  { id: 248, name: 'Turcas y Caicos' },
  { id: 249, name: 'Islas Virgenes (Estados Unidos de América)' },
  { id: 250, name: 'Martinica' },
  { id: 251, name: 'Puerto Rico' },
  { id: 252, name: 'Monserrat' },
  { id: 253, name: 'Groenlandia' },
  { id: 301, name: 'Jordania' },
  { id: 302, name: 'Arabia Saudita' },
  { id: 303, name: 'Kuwait' },
  { id: 304, name: 'Omán' },
  { id: 305, name: 'Chipre' },
  { id: 306, name: 'Israel' },
  { id: 307, name: 'Iraq' },
  { id: 308, name: 'Afghanistán' },
  { id: 309, name: 'Irán' },
  { id: 310, name: 'Siria' },
  { id: 311, name: 'Libano' },
  { id: 312, name: 'Qatar' },
  { id: 313, name: 'Bahrein' },
  { id: 314, name: 'Sri Lanka' },
  { id: 315, name: 'Cambodia' },
  { id: 316, name: 'Laos' },
  { id: 317, name: 'India' },
  { id: 318, name: 'Bután' },
  { id: 319, name: 'Thailandia' },
  { id: 320, name: 'Nepal' },
  { id: 321, name: 'Bangladesh' },
  { id: 322, name: 'Palestina' },
  { id: 324, name: 'Pakistán' },
  { id: 325, name: 'Vietnam' },
  { id: 326, name: 'Myanmar (ex Birmania)' },
  { id: 327, name: 'Maldivas (Isla Maldivas)' },
  { id: 328, name: 'Indonesia' },
  { id: 329, name: 'Malasia' },
  { id: 330, name: 'Taiwán (Formosa)' },
  { id: 331, name: 'Japón' },
  { id: 332, name: 'Singapur' },
  { id: 333, name: 'Corea del Sur' },
  { id: 334, name: 'Corea del Norte' },
  { id: 335, name: 'Filipinas' },
  { id: 336, name: 'China' },
  { id: 337, name: 'Mongolia' },
  { id: 338, name: 'Territorio Británico en Asia' },
  { id: 341, name: 'Emiratos Arabes Unidos' },
  { id: 342, name: 'Hong Kong (Región administrativa especial de China)' },
  { id: 343, name: 'Territorio Portugués en Asia' },
  { id: 344, name: 'Brunei' },
  { id: 345, name: 'Macao' },
  { id: 346, name: 'República de Yemen' },
  { id: 401, name: 'Fiji' },
  { id: 402, name: 'Nauru' },
  { id: 403, name: 'Tonga (Isla Tonga)' },
  { id: 404, name: 'Samoa Occidental' },
  { id: 405, name: 'Nueva Zelandia' },
  { id: 406, name: 'Australia' },
  { id: 407, name: 'Territorio Británico en Oceanía y el Pacífico' },
  { id: 408, name: 'Territorio Francés en Oceanía y el Pacífico' },
  { id: 409, name: 'Territorio NorteAméricano en Oceanía y el Pacífico' },
  { id: 412, name: 'Papua Nueva Guinea' },
  { id: 415, name: 'Vanuatu' },
  { id: 416, name: 'Kiribati' },
  { id: 417, name: 'Micronesia' },
  { id: 418, name: 'Islas Salomón' },
  { id: 419, name: 'Tuvalu' },
  { id: 420, name: 'Palau (ex Belau)' },
  { id: 421, name: 'Niue' },
  { id: 422, name: 'Polinesia Francesa' },
  { id: 423, name: 'Nueva Caledonia' },
  { id: 424, name: 'Islas Marianas del Norte' },
  { id: 425, name: 'Guam' },
  { id: 426, name: 'Timor Oriental' },
  { id: 427, name: 'Islas Cook' },
  { id: 501, name: 'Portugal' },
  { id: 502, name: 'Alemania F.R.' },
  { id: 503, name: 'Alemania R.D.' },
  { id: 504, name: 'Italia' },
  { id: 505, name: 'Francia' },
  { id: 506, name: 'Irlanda' },
  { id: 507, name: 'Dinamarca' },
  { id: 508, name: 'Suiza' },
  { id: 509, name: 'Austria' },
  { id: 510, name: 'Reino Unido' },
  { id: 511, name: 'Suecia' },
  { id: 512, name: 'Finlandia' },
  { id: 513, name: 'Noruega' },
  { id: 514, name: 'Bélgica' },
  { id: 515, name: 'Holanda' },
  { id: 516, name: 'Islandia' },
  { id: 517, name: 'España' },
  { id: 518, name: 'Albania' },
  { id: 519, name: 'Rumania' },
  { id: 520, name: 'Grecia' },
  { id: 521, name: 'U.R.S.S.' },
  { id: 522, name: 'Turquia' },
  { id: 523, name: 'Malta' },
  { id: 524, name: 'Santa Sede (Ciudad del Vaticano)' },
  { id: 525, name: 'Andorra' },
  { id: 526, name: 'Yugoeslavia' },
  { id: 527, name: 'Bulgaria' },
  { id: 528, name: 'Polonia' },
  { id: 529, name: 'Otros de Europa' },
  { id: 530, name: 'Hungria' },
  { id: 532, name: 'Luxemburgo' },
  { id: 534, name: 'Liechtenstein' },
  { id: 535, name: 'Monaco' },
  { id: 536, name: 'San Marino' },
  { id: 540, name: 'Armenia' },
  { id: 541, name: 'Azerbaiyan' },
  { id: 542, name: 'Belarus' },
  { id: 543, name: 'Bosnia y Herzegovina' },
  { id: 544, name: 'República Checa' },
  { id: 545, name: 'República Eslovaca' },
  { id: 546, name: 'República de Serbia' },
  { id: 547, name: 'Croacia' },
  { id: 548, name: 'Eslovenia' },
  { id: 549, name: 'Estonia' },
  { id: 550, name: 'Georgia' },
  { id: 551, name: 'Kasajstán' },
  { id: 552, name: 'Kirgistán' },
  { id: 553, name: 'Letonia' },
  { id: 554, name: 'Lituania' },
  { id: 555, name: 'Macedonia' },
  { id: 556, name: 'Moldova' },
  { id: 557, name: 'Tadjikistán' },
  { id: 558, name: 'Turkmenistán' },
  { id: 559, name: 'Ucrania' },
  { id: 560, name: 'Uzbekistan' },
  { id: 561, name: 'Montenegro' },
  { id: 562, name: 'Rusia' },
  { id: 563, name: 'Alemania' },
  { id: 564, name: 'RF Yugoeslavia' },
  { id: 565, name: 'Gibraltar' },
  { id: 566, name: 'Guernsey' },
  { id: 567, name: 'Isla de Man' },
  { id: 568, name: 'Jersey' },
  { id: 585, name: 'Gibraltar' },
  { id: 888, name: 'Resto del Mundo' },
  { id: 901, name: 'Combustibles y lubricantes destinados al consumo de naves y aeronaves extranjeras y de revistas con el mismo objeto' },
  { id: 902, name: 'Aprovisionamiento (Rancho) de naves y aeronaves extranjeras y de maderas para estibar mercancías cargadas en puertos chilenos' },
  { id: 903, name: 'Pesca Extraterritorial' },
  { id: 904, name: 'Origenes o Destinaciones no precisadas por razones comerciales o militares' },
  { id: 905, name: 'Zona franca Iquique' },
  { id: 906, name: 'Depósito franco' },
  { id: 907, name: 'Zona franca Punta Arenas' },
  { id: 910, name: 'Zona Franca Arica, Zona Industrial' },
  { id: 997, name: 'Chile' },
  { id: 998, name: 'Nacional reputada' },
  { id: 999, name: 'Otros' }
]